import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  Box1NegatievePersoonsgebondenAftrek, IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';


@Component({
  selector:
    'snelstart-venture-fiscaal-feature-box1-negatieve-persoonsgebonden-aftrek',
  templateUrl: './box1-negatieve-persoonsgebonden-aftrek.component.html',
  styleUrls: ['./box1-negatieve-persoonsgebonden-aftrek.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class Box1NegatievePersoonsgebondenAftrekComponent implements OnInit, OnDestroy {

  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
  private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public aangifte = {} as Aangifte;
    private incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    public year = 2024;

    public showSpinner = true;

    public negatievePGA = this.fb.group<Box1NegatievePersoonsgebondenAftrek>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.negatievePGA = this.fb.group<Box1NegatievePersoonsgebondenAftrek>({
            terugontvangenAlimentatie: null as unknown as number,
            inkomstenSpecifiekeZiektekosten: null as unknown as number,
            inkomstenOverigStudiekosten: null as unknown as number,
            inkomstenOverigOnderhoudMonumentenpanden: null as unknown as number,
            inkomstenOverigGiften: null as unknown as number,
            inkomstenOverigTeruggekregenKwijtgescholdenDurfkapitaal: null as unknown as number,
        })
    }


    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.negatievePGA.reset()
                    this.updateForm();
                });
                if (incomeTaxEntity.year !== undefined) {
                    this.year = incomeTaxEntity.year;
                }
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      });
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.negatievePGA.dirty;
  }

    private updateForm() {
        this.partner.subscribe((partner) => {
            if (!partner) {
                this.negatievePGA.patchValue(this.aangifte?.box1?.negatievePersoonsgebondenAftrek || null as unknown as Box1NegatievePersoonsgebondenAftrek,);
            } else {
                this.negatievePGA.patchValue(this.aangifte?.partnerAangifte?.box1?.negatievePersoonsgebondenAftrek || null as unknown as Box1NegatievePersoonsgebondenAftrek,);
            }
        })
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    negatievePersoonsgebondenAftrek: this.negatievePGA.value
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        negatievePersoonsgebondenAftrek: this.negatievePGA.value
                    }
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.negatievePGA.markAsDirty()
        }
    }
}
